import {
    ENABLE_ACCOUNT_ERROR,
    ENABLE_ACCOUNT_ERROR_CLEAR,
    ENABLE_ACCOUNT_PENDING,
    ENABLE_ACCOUNT_SUCCESS,
} from "./constants"

const initialState = {
    isEnableAccountPending: false,
    enableAccountErrorMessage: null,
    isSuccess: false,
}

const enableAccount = (state = initialState, action) => {

    switch (action.type) {
        case ENABLE_ACCOUNT_PENDING: {
            return {
                ...state,
                isEnableAccountPending: true
            }
        }

        case ENABLE_ACCOUNT_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...state,
                enableAccountErrorMessage: errorMessage,
                isEnableAccountPending: false,
                isSuccess: false,
            }
        }

        case ENABLE_ACCOUNT_ERROR_CLEAR: {
            return {
                ...state,
                enableAccountErrorMessage: null,
                isEnableAccountPending: false,
                isSuccess: false,
            }
        }

        case ENABLE_ACCOUNT_SUCCESS: {
            return {
                ...state,
                isSuccess: true,
                enableAccountErrorMessage: null,
                isEnableAccountPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default enableAccount;